<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Select Departments</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Close">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <!-- Search Bar -->
  <ion-toolbar>
    <ion-searchbar
      [(ngModel)]="searchTerm"
      (ionInput)="filterDepartments()"
      placeholder="Search departments..."
      debounce="300"
      animated="true"
      showClearButton="always">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="modal-content-wrapper">
    <!-- Selected Departments Section -->
    <div class="section-container" *ngIf="selectedCount > 0">
      <div class="section-header selected-header">
        <ion-icon name="checkmark-circle" class="section-icon"></ion-icon>
        <h3 class="section-title">Selected</h3>
        <ion-badge color="primary" class="count-badge">{{selectedCount}}</ion-badge>
      </div>

      <ion-list class="dept-list">
        <ion-item
          *ngFor="let dept of getSelectedDepartments()"
          lines="full"
          button="true"
          (click)="toggleDepartment(dept)"
          class="dept-item selected-item">
          <ion-checkbox
            slot="start"
            [checked]="true"
            (ionChange)="toggleDepartment(dept, $event)"
            aria-label="Deselect department">
          </ion-checkbox>
          <ion-label class="dept-label">{{dept.name}}</ion-label>
          <ion-icon
            slot="end"
            name="remove-circle-outline"
            class="remove-icon"
            color="danger">
          </ion-icon>
        </ion-item>
      </ion-list>
    </div>

    <!-- Available Departments Section -->
    <div class="section-container" *ngIf="hasFilteredResults">
      <div class="section-header available-header">
        <ion-icon name="list-outline" class="section-icon"></ion-icon>
        <h3 class="section-title">Available</h3>
        <ion-badge color="medium" class="count-badge">{{availableCount}}</ion-badge>
      </div>

      <ion-list class="dept-list">
        <ion-item
          *ngFor="let dept of getAvailableDepartments()"
          lines="full"
          button="true"
          (click)="toggleDepartment(dept)"
          class="dept-item available-item">
          <ion-checkbox
            slot="start"
            [checked]="false"
            (ionChange)="toggleDepartment(dept, $event)"
            aria-label="Select department">
          </ion-checkbox>
          <ion-label class="dept-label" [innerHTML]="highlightMatch(dept.name)"></ion-label>
          <ion-icon
            slot="end"
            name="add-circle-outline"
            class="add-icon"
            color="primary">
          </ion-icon>
        </ion-item>
      </ion-list>
    </div>

    <!-- No Results State -->
    <div class="empty-state" *ngIf="noSearchResults">
      <ion-icon name="search-outline" class="empty-icon"></ion-icon>
      <h3 class="empty-title">No departments found</h3>
      <p class="empty-text">Try adjusting your search term</p>
    </div>

    <!-- No Departments Available -->
    <div class="empty-state" *ngIf="allDepartments.length === 0">
      <ion-icon name="business-outline" class="empty-icon"></ion-icon>
      <h3 class="empty-title">No departments available</h3>
      <p class="empty-text">Please contact your administrator</p>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="footer-actions">
      <!-- Left Actions -->
      <div class="footer-left">
        <ion-button
          fill="clear"
          color="danger"
          (click)="clearAll()"
          [disabled]="selectedCount === 0">
          <ion-icon slot="start" name="trash-outline"></ion-icon>
          Clear All
        </ion-button>

        <ion-button
          fill="clear"
          color="primary"
          (click)="selectAll()"
          [disabled]="availableCount === 0">
          <ion-icon slot="start" name="checkbox-outline"></ion-icon>
          Select All
        </ion-button>
      </div>

      <!-- Right Actions -->
      <div class="footer-right">
        <ion-button
          fill="solid"
          color="primary"
          (click)="confirm()">
          <ion-icon slot="start" name="checkmark-circle"></ion-icon>
          Done
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>
